module.exports = __webpack_public_path__ + "img/suporte_ws.faf33b9d.png";